"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Grouping = void 0;
const BasicEnumerable_1 = require("./BasicEnumerable");
/**
 * Represents a collection of objects that have a common key.
 * @typeparam TKey The type of the key.
 * @typeparam TSource The type of the values.
 */
class Grouping extends BasicEnumerable_1.BasicEnumerable {
    constructor(factory, key, src) {
        super(factory, src);
        this.key = key;
    }
}
exports.Grouping = Grouping;
//# sourceMappingURL=Grouping.js.map